/* Non-component exports for Sheet.jsx — kept out of the .jsx file so fast
 * refresh keeps working there (same split as authStyles.js / AuthPanel.jsx). */
import { C, T } from "./theme.js";

export const sheetSection = {
  ...T.title,
  borderTop: `1px solid ${C.faint}`,
  color: C.ink,
  fontSize: 17,
  marginTop: 18,
  paddingTop: 14,
};

/* Where a tab contributes its own settings to the unified panel. The Ledger
 * portals into this rather than having its prefs lifted into App: `username`
 * and `site` are load-bearing for cache keys and for the sign-in hydrate race
 * recorded in TODO.md › Rules that bind › Data safety, and moving that state is a much
 * bigger risk than rendering a few controls through a portal. */
export const SETTINGS_SLOT_ID = "towardsgm-settings-slot";
